import { Typography } from "@material-ui/core";
import { get } from "lodash";
import React from "react";
import { FileField } from "react-admin";

const CsvField = ({ record, basePath, ...props }) => {
	const csv = get(record, "csv", {});
	const path = get(record, "csv.path");
	const name = get(record, "csv.name");
	const modifiedRecord = {
		...record,
		csv: {
			...csv,
			path: `${path}?token=${localStorage.getItem("token")}`,
			name,
		},
	};
	return (
		<Typography {...props} component="div">
			<FileField
				source={props.source}
				title={props.title}
				record={modifiedRecord}
				basePath={basePath}
				{...props}
			/>
		</Typography>
	);
};

export default CsvField;
